import React, { FC } from "react";
import { useFormatter } from "kw/util/useFormatter";
import { SummaryTable } from "kw/admin/components/SummaryTable";

type TClaimSummarySection = {
  claim: TClaim;
};

export const ClaimSummarySection: FC<TClaimSummarySection> = ({ claim }) => {
  const { formatDate, formatString } = useFormatter();
  const customerDetails = [
    {
      id: "claim-id",
      label: "Claim ID",
      value: formatString(claim?.id),
    },
    {
      id: "policy-number",
      label: "Policy Number",
      value: formatString(claim?.policyNumber),
    },
    {
      id: "insurance-type",
      label: "Insurance type",
      value: formatString(claim?.claimProfile?.products?.[0]?.name),
    },
    {
      id: "submit-date",
      label: "Submit date",
      value: formatDate(claim?.created),
    },
  ];
  if (claim?.closedDate) {
    customerDetails.push({
      id: "close-date",
      label: "Close date",
      value: formatDate(claim?.closedDate),
    });
  }
  return <SummaryTable data={customerDetails} type="CUSTOMER" />;
};
